module.exports = __webpack_public_path__ + "img/come-vict-03.99146289.jpg";